export const FLOW_EVENTS = {
  READ: "FLOW:READ",
  UPDATE: "FLOW:UPDATE",
  CREATE: "FLOW:CREATE",
  DELETE: "FLOW:DELETE",
  ARCHIVE: "FLOW:ARCHIVE",
  UNARCHIVE: "FLOW:UNARCHIVE",
  FAVORITE: "FLOW:FAVORITE",
  UNFAVORITE: "FLOW:UNFAVORITE"
};
